import Closer1 from './asset/Editions/Closer1.jpg';
import Closer2 from './asset/Editions/Closer2.jpg';
import Closer3 from './asset/Editions/Closer3.jpg';
import Closer4 from './asset/Editions/Closer4.gif';
import Closer5 from './asset/Editions/Closer5.jpg';
import Closer6 from './asset/Editions/Closer6.gif';
import PDB1 from './asset/Editions/PDB1.jpg';
import PDB2 from './asset/Editions/PDB2.jpg';
import PDB3 from './asset/Editions/PDB3.jpg';
import PDB4 from './asset/Editions/PDB4.jpg';
import PDB5 from './asset/Editions/PDB5.jpg';
import PDB6 from './asset/Editions/PDB6.jpg';
import PDB7 from './asset/Editions/PDB7.jpg';
import PDB8 from './asset/Editions/PDB8.jpg';
import PDB9 from './asset/Editions/PDB9.jpg';
import PDB10 from './asset/Editions/PDB10.jpg';
import PDB11 from './asset/Editions/PDB11.jpg';
import PDB12  from './asset/Editions/PDB12.jpg';
import AAC1 from './asset/Editions/AAC1.jpg';
import AAC2 from './asset/Editions/AAC2.jpg';
import AAC3 from './asset/Editions/AAC3.jpg';
import AAC4 from './asset/Editions/AAC5.jpg';
import AAC5 from './asset/Editions/AAC6.jpg';
import Passage1 from './asset/Editions/Passage1.jpg';
import Passage2 from './asset/Editions/Passage2.jpg';
import Passage3 from './asset/Editions/Passage3.jpg';
import Passage4 from './asset/Editions/Passage4.jpg';
import Passage5 from './asset/Editions/Passage5.jpg';
import NPC1 from './asset/Editions/NPC1.jpg';
import NPC2 from './asset/Editions/NPC2.jpg';
import NPC3 from './asset/Editions/NPC3.jpg';
import NPC4 from './asset/Editions/NPC4.jpg';
import JDP1 from './asset/Interface/JDP.png';
import JDP2 from './asset/Interface/JDP.mp4';
import AN1 from './asset/Interface/AN1.jpg';
import AN2 from './asset/Interface/AN2.jpg';
import AN3 from './asset/Interface/AN3.jpg';
import AN4 from './asset/Interface/AN4.jpg';
import AN5 from './asset/Interface/AN5.jpg';
import AN6 from './asset/Interface/AN6.jpg';
import Focus1 from './asset/Interface/FOCUS1.png';
import Focus2 from './asset/Interface/FOCUS2.png';
import Focus3 from './asset/Interface/FOCUS3.png';
import Migratio1 from './asset/Interface/Migratio1.png';
import Migratio2 from './asset/Interface/Migratio2.mp4';
import LAB1 from './asset/Lab/LAB1.gif';
import LAB2 from './asset/Lab/LAB2.gif';
import LAB3 from './asset/Lab/LAB3.gif';
import LAB4 from './asset/Lab/LAB4.jpg';
import LAB5 from './asset/Lab/LAB5.gif';
// import LAB6 from './asset/Lab/LAB6.mp4';
import LAB7 from './asset/Lab/LAB7.jpg';
import LAB8 from './asset/Lab/LAB8.gif';
import LAB9 from './asset/Lab/LAB9.gif';
import LAB10 from './asset/Lab/LAB10.gif';
import LAB11 from './asset/Lab/LAB11.jpg';
import LAB12 from './asset/Lab/LAB12.jpg';
import LAB13 from './asset/Lab/LAB13.png';
import LAB14 from './asset/Lab/LAB14.jpg';
import LAB15 from './asset/Lab/LAB15.jpg';
import LAB16 from './asset/Lab/LAB16.png';
import LAB17 from './asset/Lab/LAB17.jpg';
import LAB18 from './asset/Lab/LAB18.jpg';
import LAB19 from './asset/Lab/LAB19.jpg';
import LAB20 from './asset/Lab/LAB20.jpg';
import LAB21 from './asset/Lab/LAB21.png';
import LAB22 from './asset/Lab/LAB22.jpg';
import LAB23 from './asset/Lab/LAB23.gif';
import LAB24 from './asset/Lab/LAB24.jpg';
import LAB25 from './asset/Lab/LAB25.jpg';
import LAB26 from './asset/Lab/LAB26.jpg';
import FDD1 from './asset/Motion/FDD1.mp4';
import FDD3 from './asset/Motion/FDD2.gif';
import FDD2 from './asset/Motion/FDD3.jpg';
import StillMoving1 from './asset/Motion/StillMoving1.jpg';
import StillMoving2 from './asset/Motion/StillMoving2.jpg';
import StillMoving3 from './asset/Motion/StillMoving3.jpg';
import StillMoving4 from './asset/Motion/StillMoving4.jpg';
import StillMoving5 from './asset/Motion/StillMoving5.jpg';
import StillMoving6 from './asset/Motion/StillMoving6.jpg';
import StillMoving7 from './asset/Motion/StillMoving7.jpg';
import StillMoving8 from './asset/Motion/StillMoving8.gif';
import StillMoving9 from './asset/Motion/StillMoving9.mp4';
import GarageType1 from './asset/Typographie/GarageType1.jpg';
import GarageType2 from './asset/Typographie/GarageType2.jpg';
import GarageType3 from './asset/Typographie/GarageType3.jpg';
import GarageType4 from './asset/Typographie/GarageType4.jpg';
import GarageType5 from './asset/Typographie/GarageType5.jpg';
import GarageType6 from './asset/Typographie/GarageType6.jpg';
import GarageType7 from './asset/Typographie/GarageType7.jpg';
import GarageType8 from './asset/Typographie/GarageType8.jpg';
import GarageType9 from './asset/Typographie/GarageType9.jpg';
import GarageType10 from './asset/Typographie/GarageType10.jpg';
import Zéphire1 from './asset/Typographie/Zéphire1.jpg';
import Zéphire2 from './asset/Typographie/Zéphire2.jpg';
import Zéphire3 from './asset/Typographie/Zéphire3.jpg';
import Zéphire4 from './asset/Typographie/Zéphire4.jpg';
import Zéphire5 from './asset/Typographie/Zéphire5.jpg';
import Zéphire6 from './asset/Typographie/Zéphire6.jpg';
import Zéphire7 from './asset/Typographie/Zéphire7.jpg';
import Zéphire8 from './asset/Typographie/Zéphire8.jpg';
import Zéphire9 from './asset/Typographie/Zéphire9.gif';
import Lgc from './asset/lgconver.jpg';
import Content from './asset/Contentmesh.png';
import Memoire from './asset/memoire.png'
import Coverceont from "./asset/cover-content.png"
import Covercram from "./asset/cover-caram.png"
import CoverPerf from "./asset/performercover.png"
import CoverZoo from "./asset/cover-zoo.png"
import CoverOmn from "./asset/cover-omni.png"
import Zoo1 from "./asset/zoo1.png"
import Zoo2 from "./asset/zoo2.gif"
import Zoo3 from "./asset/zoo3.png"
import Zoo4 from "./asset/zoo4.gif"
import Zoo5 from "./asset/zoo5.png"
import Zoo6 from "./asset/zoo6.gif"
import Zoo7 from "./asset/zoo7.png"
import Om1 from "./asset/om1.png"
import Om2 from "./asset/om2.gif"
import Om3 from "./asset/om3.png"
import Caram1 from "./asset/caram1.png"
import Caram2 from "./asset/caram2.gif"
import Caram3 from "./asset/caram3.png"
import Caram4 from "./asset/caram4.gif"
import Caram5 from "./asset/caram5.png"
import Symbio1 from "./asset/Symbiose-1.png"
import Symbio2 from "./asset/Symbiose-2.gif"
import Symbio3 from "./asset/Symbiose-3.png"
import CoverSymbio from "./asset/cover-symbiose.png"
import Femme1 from "./asset/femme1.png"
import Femme2 from "./asset/femme2.png"
import Femme3 from "./asset/femme3.png"
import Femme4 from "./asset/femme4.png"
import Femme5 from "./asset/femme5.png"
import Femme6 from "./asset/femme6.png"
import Femme7 from "./asset/femme7.png"
import Femme8 from "./asset/femme8.png"
import Femme9 from "./asset/femme9.png"
import Femme10 from "./asset/femme10.png"
import Femme11 from "./asset/femme11.png"
import Femme13 from "./asset/femme13.gif"
import Femme14 from "./asset/femme14.png"
import Jardin1 from "./asset/jardin1.png"
import Jardin2 from "./asset/jardin2.png"
import Jardin3 from "./asset/jardin3.png"
import Jardin4 from "./asset/jardin4.png"
import Text1 from "./asset/Txt-img-1.png"
import Text2 from "./asset/Txt-img-2.png"
import Text3 from "./asset/Txt-img-3.png"
import Text4 from "./asset/Txt-img-4.png"
import Text5 from "./asset/Txt-img-5.png"
import Text6 from "./asset/Txt-img-6.png"
import Text7 from "./asset/Txt-img-7.png"
import Text8 from "./asset/Txt-img-8.png"
import Text9 from "./asset/Txt-img-9.png"
import Text10 from "./asset/Txt-img-10.png"

const projets = [
  // --- PROJETS (du plus récent au plus ancien) ---
  {
    id:0,
    titre:"Caram'elles",
    categorie: "projet",
    date:2025,
    hashtag:["#Branding #WebDesign #UI/UX"],
    technique:"Affiche/Livret A2,Impression Riso",
    descritpion:"Catalogue d'exposition réalisé à la demande d'Éric Choisy Bernard, Artiste, Designer Numérique, Bricodeur et enseignant.",
    images:[Caram1, Caram2,Caram3,Caram4,Caram5],
    link:"https://www.figma.com/proto/OYbCiD8Cw06suCYo9sfGAE/%F0%9F%8C%B7-Caramelles?page-id=4%3A2&node-id=604-4061&viewport=492%2C-1968%2C0.06&t=hrKEsO69tNqOSWqM-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=604%3A4061",
    cover:Covercram,
  },
  {
    id:1,
    titre:"Symbiose Pharma",
    categorie: "projet",
    date:2025,
    hashtag:["#UX #UI #Interface #IntegrationWeb "],
    technique:"Figma,Wordpress",
    descritpion:"",
    images:[Symbio1, Symbio2, Symbio3],
    cover:CoverSymbio,
  },
  {
    id:2,
    titre:"Content Mesh",
    categorie: "projet",
    date:2024,
    hashtag:["#Interface #UX #UI #UserResearch"],
    technique:"Esquisse numérique",
    contexte:"Lors d'un hackathon, nous avons été sollicités pour concevoir une interface permettant aux utilisateurs de traduire des contenus audiovisuels tout en préservant l’émotion et l’authenticité de la voix originale.",
    proposition:"Pour répondre à cette demande, nous avons d'abord identifié notre public cible : les créateurs de contenu. Cette identification nous a conduits à développer une interface conçue pour aider ces créateurs à élargir leur audience. L’outil propose la traduction de leurs contenus en s’appuyant sur des suggestions de régions géographiques et de plateformes les plus susceptibles de consommer leur production.",
    images:[Content],
    cover:Coverceont,
    link:"https://www.figma.com/proto/qb3uyeBZqFV476EFANP6cC/ContentMesh?page-id=59%3A471&type=design&node-id=59-1599&t=wa2yxEljBkoeN93e-0&scaling=scale-down&starting-point-node-id=59%3A1662&show-proto-sidebar=1&hide-ui=1",
    liensProto:"https://www.figma.com/proto/qb3uyeBZqFV476EFANP6cC/ContentMesh?page-id=59%3A471&type=design&node-id=59-1599&t=wa2yxEljBkoeN93e-0&scaling=scale-down&starting-point-node-id=59%3A1662&show-proto-sidebar=1&hide-ui=1"
  },
  {
    id:3,
    titre:"Collection Zoologique",
    categorie: "projet",
    date:2024,
    hashtag:["#UX #UI #Interface #DA "],
    technique:"Esquisse numérique",
    contexte:"La Collection de Zoologie de Santiago Aragon constitue un patrimoine scientifique d’exception, regroupant plusieurs milliers de spécimens, parmi lesquels des animaux naturalisés et des pièces anatomiques historiques. Ce projet avait pour ambition de mettre en valeur cette collection à travers une approche immersive et pédagogique, favorisant son accessibilité tant pour le grand public que pour les étudiants. En intégrant des outils numériques, l’objectif était de moderniser la transmission des connaissances tout en préservant l’héritage scientifique et culturel de cette collection unique.",
    proposition:"Après nos échanges avec Santiago Aragon et la visite du site, nous avons identifié plusieurs enjeux liés à la Collection Zoologique. Son approche narrative, axée sur l’histoire individuelle de chaque animal, crée une expérience immersive et empathique, peu commune dans les musées traditionnels. Au-delà de son intérêt scientifique, Santiago souhaite utiliser cette collection comme un levier de réflexion sur l’Anthropocène, élargissant ainsi son impact. Toutefois, son emplacement au sein de l’université limite sa visibilité et sa reconnaissance. L’absence d’informations écrites, compensée par l’interaction directe avec Santiago, soulève la question de la transmission du savoir. Enfin, son rôle essentiel dans l’expérience des visiteurs met en évidence la nécessité de préserver et de pérenniser son influence au sein de la collection.",
    images:[Zoo1,Zoo2,Zoo3,Zoo4,Zoo5,Zoo6,Zoo7],
    cover:CoverZoo,
    link:"https://www.figma.com/proto/weXuDDwouKhJLL9tgtwWeA/%F0%9F%93%9A-%5BProjet-pro%5D-Delivery-(Copy)?page-id=1428%3A325&node-id=1905-1590&viewport=-3227%2C392%2C0.19&t=uEKPeNqjRixtwiZW-1&scaling=min-zoom&content-scaling=fixed",
    liensProto:"https://www.figma.com/proto/weXuDDwouKhJLL9tgtwWeA/%F0%9F%93%9A-%5BProjet-pro%5D-Delivery-(Copy)?page-id=1428%3A325&node-id=1905-1590&viewport=-3227%2C392%2C0.19&t=uEKPeNqjRixtwiZW-1&scaling=min-zoom&content-scaling=fixed"
  },
  {
    id:4,
    titre:"Omnicity",
    categorie: "projet",
    date:2024,
    hashtag:["#Branding #WebDesign #UI/UX"],
    technique:"Affiche/Livret A2,Impression Riso",
    descritpion:"Catalogue d'exposition réalisé à la demande d'Éric Choisy Bernard, Artiste, Designer Numérique, Bricodeur et enseignant.",
    images:[Om1, Om2, Om3],
    link:"https://deluxe-semifreddo-ffc501.netlify.app/",
    cover:CoverOmn,
  },

  // --- ARCHIVES (du plus récent au plus ancien) ---
  {
    id:5,
    titre:"Performer l'identité",
    categorie: "archive",
    date:2024,
    hashtag:["#Recherche #CreativeCoding"],
    technique:"Esquisse numérique",
    contexte:"Les enjeux de ce mémoire résident dans l’exploration de la manière dont les designers graphiques peuvent s’émanciper des logiciels de PAO traditionnels, comme ceux de ma suite Adobe, pour adopter la programmation dans la création d’identités visuelles. Il s’agit de comprendre comment la programmation peut offrir de nouvelles libertés créatives et permettre la génération d’identités visuelles plus flexibles et évolutives, adaptées aux exigences actuelles du design numérique. Toutefois, cette transition présente des défis, notamment la complexité cognitive et technique que l’apprentissage du code impose aux designers. Le mémoire questionne ainsi le rapport entre créativité, outils numériques et liberté du geste du designer, tout en proposant une réflexion sur l’avenir de la discipline graphique dans un monde où la programmation pourrait jouer un rôle central.",
    proposition:"Pour la publication de mon mémoire Performer l’identité, j’ai d’abord conçu une version imprimée soignée. La couverture intègre un motif en embossage généré par un algorithme de tri aléatoire, positionnant des caractères typographiques issus de mes recherches. Dessinés, découpés au laser et transformés en normographes, ces caractères ont permis la création du motif. Une version web a ensuite été développée pour en faciliter la diffusion.",
    images:[Memoire],
    cover:CoverPerf,
    thumbnail:CoverPerf,
    liensSite:"https://memoire-leonie-nollevalle.netlify.app/"
  },
  {
    id:6,
    titre:"Paysage Typographique",
    categorie: "archive",
    date:2024,
    hashtag:["#CreativeCoding #Typographie"],
    technique:"Esquisse numérique",
    descritpion:"Nous avons mis en scène ces nouveaux caractères à travers quatre éléments : sable, végétaux, eau et feu. Chaque mise en scène permet, grâce à la souris matérialisant l’effet du vent, de créer des expériences interactives sur chacun de ces éléments. La confrontation de chacun des éléments dans la page rappelle la dualité créée dans les caractères typographiques.",
    images:[Jardin1, Jardin2, Jardin3, Jardin4],
    liensProto:"https://master--animated-dango-1a653b.netlify.app/",
    thumbnail:Jardin1,
  },
  {
    id:7,
    titre:"Texte-Image",
    categorie: "archive",
    date:2024,
    hashtag:["#Édition #DA #IA"],
    technique:"Esquisse numérique",
    descritpion:"« Nous ne regardons jamais une seule chose,nous regardons toujours la relation entre les choses et nous-mêmes. » – John Berger",
    images:[Text1, Text2, Text3, Text4, Text5, Text6, Text7, Text8, Text9, Text10],
    thumbnail:Text1,
  },
  {
    id:8,
    titre:"La Grande Conversation",
    categorie: "archive",
    date:2023,
    hashtag:["#Interface #musée #UX #UI"],
    technique:"Esquisse numérique",
    contexte:"Dans le cadre d'une sollicitation du centre d'exposition La Maison Laurentine, nous avons été invités à participer au cycle d'exposition La Grande Conversation. Pour ce projet, nous devions concevoir un dispositif en adéquation avec ce cycle, initié par l'enregistrement de 21 entretiens. Ces personnes ont été filmées en train d'échanger face caméra, dans le but de replacer les visiteurs au cœur de l'exposition et de les inciter à entrer en conversation. ",
    proposition:"La proposition que nous avons esquissée intègre la conversation après la visite, à travers les traces laissées par le visiteur. Le dispositif que nous avons conçu se déroule en deux temps. Dans un premier temps, le visiteur explore l'exposition en scannant une carte NFC sur des bornes interactives. Celles-ci lui permettent d’annoter ses impressions sous forme de carnet de voyage, qui seront ensuite enregistrées sur la carte. Dans un second temps, le visiteur peut récupérer les informations de sa carte en la scannant ou en accédant au site de l'exposition. Il y retrouvera le parcours qu'il a suivi ainsi que ses annotations faites durant la visite. Ainsi, à partir des traces laissées par chaque visiteur, une conversation s’engage non seulement pendant l'exposition, mais surtout après, lorsque l'utilisateur revisite son carnet de voyage et revit son expérience à travers les souvenirs de son passage.",
    images:[Lgc],
    liensProto:"https://www.figma.com/proto/3f5hh2CSZzAmXJToJDWLSu/%F0%9F%96%BC%EF%B8%8F-Maison-Laurentine---Workspace-(Copy)?page-id=220%3A59&node-id=281-556&p=f&viewport=289%2C242%2C0.07&t=Jzh8RxIQQa83RYQU-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=270%3A1959",
    thumbnail:Lgc,
  },
  {
    id:9,
    titre:"Des femmes",
    categorie: "archive",
    date:2023,
    hashtag:["#Interface #Édition #Affichage #DA"],
    technique:"Esquisse numérique",
    descritpion:"Nous avons choisi un fragment de rue dans lequel nous installer. Un fragment lié aux femmes, inventé par des femmes et investi par des femmes. Il nous a semblé cohérent de choisir les éditions des femmes comme lieu d'inverstitur.",
    images:[Femme1, Femme2, Femme3, Femme4, Femme5, Femme6, Femme7, Femme8, Femme9, Femme10, Femme11, Femme13, Femme14],
    thumbnail:Femme1,
  },
  {
    id:10,
    titre:"Laboratoire",
    categorie: "archive",
    date:2022,
    hashtag:["#Expérimentation"],
    technique:"",
    descritpion:"",
    images:[LAB1, LAB2, LAB3, LAB4, LAB5, LAB7, LAB8, LAB9, LAB10, LAB11, LAB12, LAB13, LAB14, LAB15, LAB16, LAB17, LAB18, LAB19, LAB20, LAB21, LAB22, LAB23, LAB24, LAB25, LAB26],
    thumbnail:LAB1,
  },
  {
    id:11,
    titre:"Ponctué de Blanc",
    categorie: "archive",
    date:2021,
    hashtag:["#Édition #CreativeCoding"],
    technique:"Impression laser A4 plié",
    descritpion:"Sur un thème Ranger, trier, classer, il nous a été demandé de prélever des éléments de textes afin de les ranger, les trier et les classer. J’ai choisi de travailler à partir de la ponctuation; le spectateur se retrouve sans voix, le silence est la réponse apportée au classement de ce texte.",
    images:[PDB1, PDB2, PDB3, PDB4, PDB5, PDB6, PDB7, PDB8, PDB9, PDB10, PDB11, PDB12],
    thumbnail:PDB1,
  },
  {
    id:12,
    titre:"Le zéphire",
    categorie: "archive",
    date:2021,
    hashtag:["#Typographie #Édition #Photographie"],
    technique:"Esquisse numérique",
    descritpion:"Sur la thématique liberticide. Il nous a été demandé de concevoir un ensemble de caractères afin de composer des slogans avec ces derniers. Ici la thématique à été traitée sous l'angle du football. Un lieu liberticide pour le genre car centré sur la fraternité davantage que sur l'inclusivité.",
    images:[Zéphire1, Zéphire2, Zéphire3, Zéphire4, Zéphire5, Zéphire6, Zéphire7, Zéphire8, Zéphire9],
    thumbnail:Zéphire3,
  },
  {
    id:13,
    titre:"Allié au choix",
    categorie: "archive",
    date:2021,
    hashtag:["#Édition #Recherche"],
    technique:"Livret A5 32 pages/reliure spirale",
    descritpion:"Mémoire réalisé sur le lien entre le graphisme et la féminité.",
    images:[AAC1 ,AAC2, AAC3, AAC4, AAC5],
    thumbnail:AAC4,
  },
  {
    id:14,
    titre:"Passage",
    categorie: "archive",
    date:2021,
    hashtag:["#Édition #Photographie"],   
    technique:"Livret A5,Impression laser ",
    descritpion:"Livret réalisé suite à un voyage à Lisbonne durant lequel un matériel graphique a été collecté. Un matériel qui a donné naissance à une édition sur la thématique du passage. Une expérience passagère dans une ville de passage, où le temps passe et laisse des traces.",
    images:[Passage1, Passage2, Passage3, Passage4, Passage5],
    thumbnail:Passage2,
  },
  {
    id:15,
    titre:"Art dans les chapelles",
    categorie: "archive",
    date:2021,
    hashtag:["#Identité Visuelle"],
    technique:"Esquisse numérique",
    descritpion:"Création d’une identité visuelle pour le festival art dans les chapelles, basée sur la mise en lumière des artistes menant à la création d’une police de caractères modulaires prélevés dans les vitraux.",
    images:["https://i.pinimg.com/564x/76/4e/6b/764e6b8045faa14c0935291515d61a4a.jpg","https://i.pinimg.com/originals/87/ae/4d/87ae4d624fd25e627f5494118f257877.jpg", "https://i.pinimg.com/564x/72/17/a1/7217a1860e083b0705986c5436fcebe3.jpg", "https://i.pinimg.com/originals/ef/b6/3a/efb63a43858557ac401ee9335f6a69ad.jpg"],
    thumbnail:"https://i.pinimg.com/564x/76/4e/6b/764e6b8045faa14c0935291515d61a4a.jpg",
  },
  {
    id:16,
    titre:"Jdp",
    categorie: "archive",
    date:2021,
    hashtag:["#Interface Mobile #Prototype"],
    technique:"Prototype numérique/motion",
    descritpion:"Création d’une application pour l’opéra de Rennes, proposant une expérience d’écoute de musique d’opéra durant la fermeture de l’opéra ainsi qu’une présentation de sa programmation à travers des playlists de promotion.",
    images:[JDP1],
    videos:JDP2,
    thumbnail:JDP1,
  },
  {
    id:17,
    titre:"an",
    categorie: "archive",
    date:2021,
    hashtag:["#Identité visuelle #Interface #Communication"],
    technique:"Prototype numérique/papier impression laser",
    descritpion:"Dans le cadre de mon projet de fin d'études il m'a été proposé de réaliser une identité visuelle, une communication ainsi qu'un site web pour un professionnel de la dermographie",
    images:[AN1, AN2, AN3, AN4, AN5, AN6],
    thumbnail:AN1,
  },
  {
    id:18,
    titre:"Ne pas couvrir",
    categorie: "archive",
    date:2021,
    hashtag:["#Édition #Risographie"],
    technique:"Affiche/Livret A2,Impression Riso",
    descritpion:"Catalogue d'exposition réalisé à la demande d'Éric Choisy Bernard, Artiste, Designer Numérique, Bricodeur et enseignant.",
    images:[NPC1, NPC2, NPC3, NPC4],
    thumbnail:NPC1,
  },
  {
    id:19,
    titre:"Focus",
    categorie: "archive",
    date:2021,
    hashtag:["#Interfaces #DéveloppementWeb #API"],
    technique:"Site web déployé/utilisation d'une api",
    descritpion:"Création d'un site web autour du cinéma, proposant un large choix de suggestion de film aléatoire. Afin de sortir du modèle des grandes plateformes de streaming qui noie l'utilisateur dans un grand nombre de contenus",
    images:[Focus1, Focus2, Focus3],
    liensSite:"https://focus-wcs.netlify.app/",
    thumbnail:Focus1,
  },
  {
    id:20,
    titre:"GarageType",
    categorie: "archive",
    date:2020,
    hashtag:["#Typographie #Photographie #Module"],
    technique:"Esquisse numérique",
    descritpion:"Workshop confiné, où il nous a été demandé de choisir un lieu dans notre logement afin d’en ressortir des modules qui nous ont par la suite servis à créer des grilles modulaires pour finalement réaliser des caractères modulaires.",
    images:[GarageType1, GarageType2, GarageType3 ,GarageType4, GarageType5, GarageType6, GarageType7, GarageType8, GarageType9, GarageType10],
    thumbnail:GarageType1,
  },
  {
    id:21,
    titre:"Ariane",
    categorie: "archive",
    date:2020,
    hashtag:["#Identité Visuelle"],
    technique:"Esquisse numérique",
    descritpion:"Proposition d’identité visuelle réalisée durant mon stage pour l’entreprise Semia incubation, qui est une entreprise d’incubation de start-up. Une identité réalisée autour du fil d’ariane.",
    images:["https://i.pinimg.com/originals/65/2e/32/652e32d5aab49b748117d46335a30e0e.jpg", "https://i.pinimg.com/originals/17/f7/60/17f760685982ac319329670503b69af2.jpg", "https://i.pinimg.com/564x/e7/8a/29/e78a29c3d137b61114a89fc4606701e0.jpg", "https://i.pinimg.com/originals/1d/da/7c/1dda7c5497390064de2897989ced2b0c.jpg"],
    thumbnail:"https://i.pinimg.com/originals/65/2e/32/652e32d5aab49b748117d46335a30e0e.jpg",
  },
  {
    id:22,
    titre:"StillMoving",
    categorie: "archive",
    date:2020,
    hashtag:["#Motion"],
    technique:"Motion",
    descritpion:"Durant ce Workshop il nous a été demandé de prélever des éléments dans des livres qui allaient être jetés et qui étaient donc par conséquent “saccageables”.  Ces éléments nous ont par la suite aidés à monter une vidéo, avec comme fil narratif un haïku.",
    images:[StillMoving1, StillMoving2, StillMoving3, StillMoving4, StillMoving5, StillMoving6, StillMoving7, StillMoving8],
    videos:StillMoving9,
    thumbnail:StillMoving1,
  },
  {
    id:23,
    titre:"Closer",
    categorie: "archive",
    date:2019,
    hashtag:["#Édition #Photographie"],
    technique:"Impression laser livret A5 24 pages N/B",
    descritpion:"Fanzine réalisé lors d’un workshop, sur le thème de la viralité mené par Mathieu Renard issu de Lendroit Edition. Workshop qui a abouti à un fanzine composé de photographies intimistes et étouffantes,faites à partir d’un scanner pour être par la suite imprimées et photocopiées ce qui crée une dégradation de l’image.",
    images:[Closer1, Closer2, Closer3, Closer4, Closer5, Closer6],
    thumbnail:Closer1,
  },
  {
    id:24,
    titre:"Migratio",
    categorie: "archive",
    date:2019,
    hashtag:["#Interface #Maquettes"],
    technique:"Prototype numérique/motion",
    descritpion:"Prototype de site web réalisé pour le musée de Bretagne, une expérience proposant un aperçu de la collection du musée autour du vêtement, dans diverses hashtags[ telles qu]e le vêtement de travail.",
    images:[Migratio1],
    videos: Migratio2, 
    thumbnail:Migratio1,
  },
  {
    id:25,
    titre:"Fou de danse",
    categorie: "archive",
    date:2019,
    hashtag:["#Motion #Affiche"],
    technique:"Affiche animée",
    descritpion:"Workshop réalisé avec le Jardin graphique sur la thématique de la danse à partir d’univers colorimétriques imposés. À la fin de ce workshop une affiche animée a été réalisée.",
    images:[FDD3,FDD2],
    videos:FDD1,
    thumbnail:FDD3,
  },
];

export default projets;
